<!-- eslint-disable -->
<template lang="pug">
		image-input(
				:image="image",
				@input="$emit('input', $event)",
				@showSizeError="$emit('showSizeError')",
				@showFileError="$emit('showFileError')",
				@showTypeError="$emit('showTypeError')",
				:defaultImage="defaultImage",
				:imageAlt="imageAlt",
				:loadText="loadText",
				:removeText="removeText",
				:helpText="helpText",
				:error="error",
				:crop ="crop"
				:accept="accept"
		)
</template>

<script>
    /*eslint-disable*/
    import SchoolApi from "../api/school";
    import UserApi from "../api/user/user";
    import OlympiadApi from "../api/olympiad";
    import BattleApi from '../api/battle';
    import ImageInput from './ImageInput/ImageInput.vue'
    import {mapState} from 'vuex'

    export default {
        components: {ImageInput},
        model: {
          prop: "image",
          event: "input",
        },
        props: {
            accept: {
                    type: Array
            },
            image: {
                type: String
            },
            imageAlt: {
                type: String
            },
            loadText: {
                type: String
            },
            removeText: {
                type: String
            },
            helpText: {
                type: String
            },
            error: {
                type: String
            },
            crop: {
                type: Boolean,
                default: true
            },
            type: {
                type: String
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user,
            }),
        },
        data () {
            return {
                defaultImage: null
            }
        },
        watch: {
            type: {
                handler (type) {
                    if (type) {
                        this.getDefaultImageUrl();
                    }
                },
                immediate: true
            }
        },
        methods: {
            getDefaultImageUrl () {
                let api = this.getApi();
                this.defaultImage = api.getDefaultImageUrl();
                if (this.type === 'user') {
                    let selector = '';
                    if (this.authUser.type === 'student' || this.authUser.type === 'olympiad-student') {
                        selector = this.authUser.sex === 'male' ? 'boy' : 'girl';
                    } else {
                        selector = this.authUser.sex === 'male' ? 'man' : 'woman';
                    }
                    this.defaultImage = this.defaultImage.replace('users', 'users/' + selector);
                }
            },
            getApi () {
                switch (this.type) {
                    case 'school':
                        return SchoolApi;
                    case 'user':
                        return UserApi;
                    case 'olympiad':
                        return OlympiadApi;
                    case 'battle':
                        return BattleApi;
                }
            }
        }
    }
</script>
